import { render, staticRenderFns } from "./UploadedArticles.vue?vue&type=template&id=3d6656b2"
import script from "./UploadedArticles.vue?vue&type=script&lang=ts"
export * from "./UploadedArticles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports